module.exports = "/assets/site/images/mvsz_logo.jpg?d9d087f9f5f83e0aa100a9e3fedce170";